import {CartEmpty, CartList} from 'modules/cart/components'
import { CartProduct } from 'framework/cart'
import { useCart } from 'hooks/use-cart'
import type { FC } from 'react'
import { useRouter } from 'next/router'
import type { CartListItemsProps } from '.'
import {useEffect, useState} from "react";
import dynamic from 'next/dynamic'
import { isPedidoFacilSession } from 'modules/pedido-facil/utils/pedido-facil-session'

const PedidoFacilCheckout = dynamic(
  () => import('modules/pedido-facil/containers/pedido-facil-checkout/pedido-facil-checkout'),
  { ssr: false }
)

const CartListItems: FC<CartListItemsProps> = ({ canEdit = true, fromWidget, subscriptionOnly = false, expOnly = false }) => {
  const { items, updateItemQuantity, removeItem, updatePeriod, selectedSellersDeliveryMethod } = useCart()
  const router = useRouter()
  const [itemsCart, setItemsCart] = useState<CartProduct[]>([])
  const [isCart, setIsCart] = useState(false);
  const [itemsCartSubscription, setItemsCartSubscription] = useState<CartProduct[]>([])
  const [itemsCartExp, setItemsCartExp] = useState<CartProduct[]>([])
  const [isPedidoFacil, setIsPedidoFacil] = useState(false)

  const itemProps = {
    canEdit,
    onChangeItemQuantity: (id: CartProduct['id'], quantity: number) => updateItemQuantity(id.toString(), quantity),
    onChangePeriod: (id: CartProduct['id'], period: string) => updatePeriod(id.toString(), period),
    onDeleteItem: (id: CartProduct['id']) => {
      removeItem(id)
      if (!isPedidoFacil) router.reload()
    },
  }

  useEffect(() => {
    setIsPedidoFacil(isPedidoFacilSession(router.pathname))
    if (router.asPath.includes('carrinho') || router.asPath.includes('checkout')) {
      setIsCart(true);
    }
    const cartItems = items.filter((i) => (i.assinatura === undefined || i.assinatura === false) && i.type === "convencional")
    const cartItemsSubscription = items.filter((i) => i.assinatura === true)
    const cartItemsExp = items.filter((i) => i.type === "experiencia")
    setItemsCartSubscription(cartItemsSubscription as unknown as CartProduct[])
    setItemsCartExp(cartItemsExp as unknown as CartProduct[])
    setItemsCart(cartItems as unknown as CartProduct[])
  }, [items])


  return (
    <>
      {(isCart && subscriptionOnly && !fromWidget) && <CartList fromWidget={fromWidget} items={itemsCartSubscription} itemProps={itemProps} isSubscriptionCart={true} fullHeight={true} />}
      {(isCart && expOnly && !fromWidget) && <CartList fromWidget={fromWidget} items={itemsCartExp} itemProps={itemProps} className="mt-3" isSubscriptionCart={false} isExpCart={true} />}
      {(isCart && !subscriptionOnly && !expOnly && !fromWidget) && <CartList fromWidget={fromWidget} items={itemsCart} itemProps={itemProps} className="mt-3" isSubscriptionCart={false} />}
      {(fromWidget) &&
      <>
        {!isPedidoFacil && itemsCartSubscription.length > 0 && <CartList fromWidget={fromWidget} items={itemsCartSubscription} itemProps={itemProps} isExpCart={false} isSubscriptionCart={true} />}
        {itemsCartExp.length > 0 && <CartList fromWidget={fromWidget} items={itemsCartExp} itemProps={itemProps} isExpCart={true} isSubscriptionCart={false} />}
        {itemsCart.length > 0 && <CartList fromWidget={fromWidget} items={itemsCart} itemProps={itemProps} className="mt-3" isSubscriptionCart={false} />}
        {(itemsCartSubscription.length == 0 && itemsCart.length == 0 && itemsCartExp.length == 0)
          && !isPedidoFacil
          && <CartEmpty isSubscriptionCart={false} fromWidget={fromWidget} />
        }
        {isPedidoFacil && <PedidoFacilCheckout />}
      </>
      }
    </>
  )
}

export default CartListItems
